import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => {
    return (
        <div className={classes.loading}>
            <span><strong>E</strong></span>
            <span>I</span>
            <span>S</span>            
        </div>
    );
};

export default PageLoading;
